import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pitstop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (storage_path) => `${API}/files/${storage_path}`;

export const calcDefekt = (p) => api.post("/calculate-price/defekt", p).then((r) => r.data);
export const calcMount = (p) => api.post("/calculate-price/mount", p).then((r) => r.data);
export const geocodeDistance = (address) => api.post("/geocode-distance", { address }).then((r) => r.data);
export const submitFleetQuote = (p) => api.post("/fleet-quote", p).then((r) => r.data);

// Tires
export const listTires = (params = {}) => api.get("/tires", { params }).then((r) => r.data);
export const createTire = (p) => api.post("/tires", p).then((r) => r.data);
export const updateTire = (id, p) => api.patch(`/tires/${id}`, p).then((r) => r.data);
export const deleteTire = (id) => api.delete(`/tires/${id}`).then((r) => r.data);
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Auth
export const loginAdmin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

// Orders
export const createOrder = (p) => api.post("/orders", p).then((r) => r.data);
export const listOrders = () => api.get("/orders").then((r) => r.data);
export const updateOrderStatus = (id, status) =>
  api.patch(`/orders/${id}`, null, { params: { status } }).then((r) => r.data);
